
declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

import { Component     } from '@angular/core';
import { ViewChild     } from '@angular/core';
import { ElementRef    } from '@angular/core';
import { HostListener  } from '@angular/core';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'section-apartments',
    styleUrls: [ 'section-apartments.template.scss' ],
    templateUrl: 'section-apartments.template.html'
})
export class SectionApartmentsComponent {

    public current = 0;

    public modal: any = false;
    public modalMiniLogo: boolean = true;
    public animate: boolean = false;

    public gallery: any = {
        items: 1,

        nav: true,
        dots: false,
        loop: false,
        navText: ['<', '>'],

        autoplay: false,
        smartSpeed: 1000,

        responsive: {
            0: { items: 1 }
        }
    };

    public plantsGallery: any = {
        items: 1,

        nav: true,
        dots: false,
        loop: true,
        navText: ['<', '>'],

        autoplay: false,
        autoHeight: true,
        smartSpeed: 1000,

        responsive: {
            0: { items: 1 }
        }
    };

    public plantsGallery2: any = {
        items: 1,

        nav: true,
        dots: false,
        loop: true,
        navText: ['<', '>'],

        responsive: {
            0: { items: 1 }
        }
    };

    public content: any = [];
    public offsetscroll: number = 0;
    public slidePosition: number = 1;

    @ViewChild('title')
    public title!: ElementRef;

    @ViewChild('galleryEl')
    public galleryEl!: any;

    @ViewChild('plantsGalleryEl')
    public plantsGalleryEl!: any;

    @ViewChild('checkpoint')
    public checkpoint!: ElementRef;

    constructor (private console: ConsoleService,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    public goTo (a: number) {
        this.current = a;
        this.galleryEl?.navigationService.to(a);
    }

    public zoom (modal: any, index: any) {
        if (window.innerWidth > 992) return;

        let items = [];

        for (let i = 0; i < this.content[this.language].apartments.types[modal].plants.length; i++) {
            items.push({
                src: 'assets/' + this.content[this.language].apartments.types[modal].plants[i],
                w: 1800,
                h: 1285
            });
        }

        var pswpElement = document.querySelectorAll('.pswp')[0];
        let options = {
            index: index,
            focus: false,
            history: false,
            closeOnScroll: false,
            getThumbBoundsFn: (index: any) => {
                let thumb: any = document.querySelector(
                    `.plants .gallery-plants-2`
                );

                let rect: any = thumb.getBoundingClientRect();
                let scroll: number = window.pageYOffset || document.documentElement.scrollTop;

                return {
                    w: rect.width,
                    h: rect.height,
                    y: rect.top + scroll,
                    x: rect.left
                };
            }
        };

        let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();
    }

    public omodalAnimate = false;
    public omodal (a: any, animate = false) {
        if (animate) {
            this.omodalAnimate = true;
            setTimeout(() => {
                this.omodal(a);
                this.omodalAnimate = false;
            }, 200);
        } else {
            this.modal = a;

            setTimeout(() => {
                let host: any = document.querySelector('section-apartments')!;
                    host.style.zIndex = a === false ? 10 : 1000;

                    let body: any = document.querySelector('body')!;
                    body.style.overflow = a === false ? 'auto' : 'hidden';
            }, 300);
        }
        
    }

    ngOnInit () {
        this.console.info('Starting SectionApartments');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.content = main;
        }
    }

    ngOnDestroy () {
        this.console.info('Destroying SectionApartments');
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    public encapsulate (text: string) {
        return this.platform.encapsulate(text);
    }

    public translated ($event: any) {
        this.slidePosition = $event.startPosition + 1;
    }

    public translated2 ($event: any) {
        this.current = $event.startPosition;
    }

    @HostListener('window:scroll', [ '$event' ])
    @HostListener('window:resize', [ '$event' ])
    public animateBySrcoll ($event: any) {
        this.offsetscroll = window.scrollY / this.platform.offset(this.checkpoint?.nativeElement);
        this.animate = this.platform.isInView(
            this.title.nativeElement, window.innerHeight / 3
        );
    }

    redirectWhatsApp(){
        window.open("https://wa.me/5571981160642", "_blank");
    }
}
